<template>
  <div class="wrapper">
    <van-nav-bar title="实习计划" left-arrow @click-left="$router.go(-1)" z-index="99999" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="top">
      <div class="title">{{ pageData.sxjhmc }}</div>
      <div class="text">起止时间: {{ pageData.sxkssj }}～{{ pageData.sxjssj }}</div>
      <div class="text">实习类别: {{ pageData.sxlb }} </div>
      <div class="text">实习对象: {{pageData.zymc}}</div>
    </div>
    <div class="content">
      <div class="content_title">实习目的</div>
      <div class="content_text">
        {{ pageData.sxmd }}
      </div>
      <div class="content_title">实习要求</div>
      <div class="content_text">
        {{ pageData.sxyq }}
      </div>
      <div class="content_title">实习内容</div>
      <div class="content_text">
        {{ pageData.sxnr }}
      </div>
      <div class="content_kq">
        <div class="content_kq_title">考勤签到</div>
        <div class="content_kq_text">
          每日签到次数：
          <div class="color">{{ pageData.mrkqcs }}次</div>
        </div>
        <div class="content_kq_text">
          <div >可签到时间：</div> <div v-for="(item, index) in pageData.sj" :key="'time' + index">{{item.gzr}}{{item.qdkssj}}~{{item.qdjssj}}</div>
        </div>
        <div class="content_kq_text" style="display: flex">可签到地点：<p v-for="(item, index) in pageData.dz" :key="index">{{item.qdddmc}} {{qdfw}}米内</p></div>
        <div class="content_kq_text">拍照设置：
          <span v-if="pageData.qdsbxpz == '1'">签到时必须拍照</span> <span v-if="pageData.byxscbdzp == '1'">不允许上传本地照片</span>
        </div>
        <div class="content_kq_text">
          补卡设置：{{pageData.wqdbksq == '1'?'未签到或签到异常时，可提交补卡申请':'未签到或签到异常时，不可提交补卡申请'}}
        </div>
        <div class="content_kq_text">
          范围外签到：{{pageData.fwwqk == '1'?'允许在范围外签到，记录为签到地址异常':'不允许在范围外签到'}}
        </div>
        <div class="content_kq_text mb">
          外勤签到：{{pageData.fwwqk == '1'?'允许学生外勤时使用外勤签到':'不允许学生外勤时使用外勤签到'}}
        </div>
      </div>
      <div class="content_title">报告配置</div>
      <div class="content_text_b">
        <div class="line-div">
          最小应交日志数：
          <div class="color">{{ pageData.rzzxs }}</div>
        </div>
        <div class="line-div">
          提交日志最晚时间：最晚{{pageData.rztjzwsj}}天后，{{pageData.rztsj}}前
        </div>
      </div>
      <div class="content_text_b">
        <div class="line-div">
          最小应交周报数：
          <div class="color">{{ pageData.zbzxs }}</div>
        </div>
        <div class="line-div">
          提交周报最晚时间：最晚每周日{{pageData.zbtjzwsj}}天后，{{pageData.zbtjsj}}前
        </div>
      </div>
      <div class="content_text_b">
        <div class="line-div">
          最小应交月报数：
          <div class="color">{{ pageData.ybzxs }}</div>
        </div>
        <div class="line-div">
          提交月报最晚时间：下一月第{{ pageData.ybtjt }}天 {{pageData.ybtjsj}} 前
        </div>
      </div>
      <div class="content_text_b ctb">
        <div class="line-div">
          最小应交总结数：
          <div class="color">{{ pageData.zjzxs }}</div>
        </div>
      </div>
    </div>
    <statePop ref="dialog" :type="statusType"></statePop>
  </div>
</template>
<script>
import  iApi  from '@/utils/internship'
import { mapGetters } from 'vuex'
import statePop from './components/statePop.vue'
export default {
  components: {
    statePop,
  },
  data() {
    return {
      statusType: 1,
      pageData: {
        dd: [],
        fwwqk: '',
        mrkqcs: '',
        qdsbxpz: '',
        rztjzwsj: '',
        rztsj: '',
        rzzxs: '',
        sj: [],
        sxjhmc: '',
        sxjssj: '',
        sxkssj: '',
        sxmd: '',
        sxnr: '',
        sxyq: '',
        sxzy: '',
        wqdbksq: '',
        ybtjsj: '',
        ybzxs: '',
        zbtjsj: '',
        zbtjzwsj: '',
        zbzxs: '',
        zjzxs: '',
        zymc: '',
        sxlb: '',
        sxyq: ''
      },
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
  },
  async created() {
    const res = await iApi.getInternshipDetail({
      sxjhid: this.sxjhid,
    })
    this.pageData = res.data
  },
  methods: {
    openDialog() {
      this.$refs.dialog.show = true
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  margin-top: -50px;
  background: #f2f2f4;
  padding-bottom: 21px;
  .top {
    width: 375px;
    height: 123px;
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    padding-top: 10px;
    .title {
      margin-bottom: 7px;
      line-height: 25px;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      margin-left: 20px;
    }
    .text {
      margin-top: 2px;
      line-height: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      margin-left: 20px;
    }
  }
  .content {
    margin: 10px auto 40px;
    width: 345px;
    background: #ffffff;
    border-radius: 8px;
    .content_title {
      padding: 15px 15px 0 15px;
      line-height: 20px;
      font-weight: 700;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
    }
    .content_text {
      padding: 4px 15px 0 15px;
      line-height: 20px;
      font-weight: 700;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      text-align: justify;
    }
    .content_text_b {
      padding: 6px 15px;
      line-height: 20px;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      text-align: justify;
      .line-div {
        display: flex;
      }
      .color {
        color: #2e92f9;
      }
    }
    .ctb {
      padding-bottom: 20px;
    }
    .content_kq {
      width: 315px;
      // height: 233px;
      background: rgba(46, 146, 249, 0.08);
      border-radius: 8px;
      margin: 14px auto 14px;
      .content_kq_title {
        padding: 15px 15px 4px 15px;
        font-family: PingFangSC-Medium;
        font-weight: 700;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
      }
      .content_kq_text {
        width: 285px;
        padding: 0 15px;
        display: flex;
        flex-wrap: wrap;
        line-height: 20px;
        font-size: 14px;
        color: #999999;
        letter-spacing: 0;
        text-align: justify;
        .color {
          color: #2e92f9;
        }
      }
      .mb {
        padding-bottom: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/plan.vue